export default __webpack_public_path__ + "static/media/skilldormLogo2.cebbc5c9.png";